export * from '@core/js/components/common/ChangeForm/constants';

export const COMMON_REQUIRED_MESSAGE = 'playtech.mobile.system.tooltip.required';
